import React from 'react';

const StepFour = ({ form, onChange, onSubmit, onPrev, loading }) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      autoComplete="off"
    >
      <div className='input-group'>
        <label>کد معرف (اختیاری)</label>
        <input
            type="text"
            name="classifierCode"
            value={form.classifierCode}
            onChange={onChange}
            placeholder="کد معرف خود را وارد کنید"
        />
      </div>

      <div className="form-actions">
        <button type="button" className="back-btn" onClick={onPrev} disabled={loading}>
          قبلی
        </button>
        <button type="submit" className="main-btn" disabled={loading}>
          {loading ? 'در حال ثبت نام...' : 'تکمیل و ثبت نام'}
        </button>
      </div>
    </form>
  );
};

export default StepFour;